import React from 'react';

import styled from 'styled-components';

import { useCurrentProjectId } from '@adsk/alloy-provider';
import { CalendarPeopleIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import StatusColorIndicator from '@adsk/alloy-react-status-color-indicator';
import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import EntityMenuItem from '../../../EntityMenuItem';
import { Statuses } from '../helpers/consts';
import { useEntityLink } from '../helpers/useEntityLink';
import { MeetingItem } from '../types';

const statusColorIndicatorColorByStatus = {
  [Statuses.OPEN]: StatusColorIndicator.COLORS.YELLOW,
  [Statuses.ONGOING]: StatusColorIndicator.COLORS.BLUE,
  [Statuses.CLOSED]: StatusColorIndicator.COLORS.GRAY_LIGHT,
};

const StyledLabelContainer = styled.div`
  display: flex;
  align-items: center;
  ${theme.typography.bodyMedium};
  color: ${theme.colors.charcoal900};
`;

export const MeetingItemEntityMenuItem = ({
  entity,
}: {
  entity: MeetingItem;
}) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const projectId = useCurrentProjectId();
  const meetingItemLink = useEntityLink(projectId || '', entity);

  const label = (
    <StyledLabelContainer>
      {entity.status && (
        <StatusColorIndicator
          style={{
            minWidth: '0.2em',
            width: '0.2em',
            height: '1.2em',
            marginRight: 8,
          }}
          statusColor={
            statusColorIndicatorColorByStatus[entity.status as string]
          }
        />
      )}

      <OverflowTooltip
        getTargetProps={() => ({
          style: { overflow: 'hidden' },
        })}
      >
        {T.translate('ITEM_ORDER_INDEX', { order: entity.orderIndex })}
        &nbsp;
        {T.translate('IN_MEETING_NUM_TITLE', {
          num: entity.meeting.numInSeries.toString().padStart(2, '0'),
          title: entity.meeting.title,
        })}
      </OverflowTooltip>
    </StyledLabelContainer>
  );

  return (
    <EntityMenuItem
      key={entity.id}
      link={meetingItemLink}
      label={label}
      renderIcon={(p) => <CalendarPeopleIcon {...p} />}
    />
  );
};
